// IE 2026 10 02 / ODOO-5800 (заказ Игоря: свёрнутый вид сигналов — заголовок и бейджи одной строкой):
// ОДНА СТРОКА ЧИПОВ С ХВОСТОМ «+k» — общий расчёт для любой строки формы ячейки (вынесен из Dropdown.sigChips_fit, где обслуживал одну свёрнутую строку SIGNALS).
// Сейчас им пользуются: свёрнутая строка SIGNALS и строки свёрнутых видов сигналов (Causes / KPIs / Info / Show all) — Dropdown.vue.
//
// Разметка строки (контейнер box — flex-элемент, занимающий остаток строки заголовка; стили — Dropdown.vue, нескоупленный <style>):
//   <span class="dropdown-blk-sum dropdown-sig-chips dropdown-sig-one">       ← box; класс .dropdown-sig-one = режим «одна строка»; без него — чипы с переносом, без «+k»
//       <span class="dropdown-blk-chip …" [data-sig-full="полное имя"]>…</span> × N   ← чипы — ПРЯМЫЕ дети box (поиск формы тоже ищет .dropdown-blk-sum > .dropdown-blk-chip)
//       <span class="dropdown-sig-more"></span>                                ← хвост «+k»: пустой span, детей и title у Vue нет
//   </span>
// Чипы, не поместившиеся в строку вместе с хвостом, получают data-sig-cut (CSS: display none), box — data-sig-fit (CSS: первый чип сжимается многоточием);
// в хвост пишутся «+k» и подсказка — имена скрытых (data-sig-full чипа, иначе его текст). Ни этих атрибутов, ни детей хвоста у Vue нет — перерисовка их не трогает,
// пересозданный элемент приходит чистым.
//
// Вызов — ПОСЛЕ отрисовки (updated() компонента, в чьём шаблоне строка):
//   chipsOneLine_fit(box, more)   — одна строка: её контейнер и элемент «+k» (more не передан — ищется среди прямых детей box по классу .dropdown-sig-more);
//   chipsOneLine_fitAll(root)     — все строки .dropdown-sig-chips внутри root. Dropdown.updated() обходит так всю форму — в том числе строки дочерних компонентов
//                                   (смена ширины формы перерисовывает Dropdown); дочерний компонент после СВОЕЙ перерисовки зовёт расчёт сам из своего updated().
// Повторный вызов дёшев: перемер — только при другом наборе чипов (текст, классы, стиль), другой ширине строки, другом элементе «+k» или сбитых отметках
// (ширину строки задаёт заголовок и форма, не чипы — качелей нет).
import { tn } from '@/i18n'

const _fit = new WeakMap()   // box → { sig, w, n, more } прошлого расчёта; n — сколько чипов оставлено видимыми (-1 — урезания нет)

export function chipsOneLine_fit(box, more) {
    if (!box || !box.children) return
    if (!more) more = box.querySelector(':scope > .dropdown-sig-more')
    const one = box.classList.contains('dropdown-sig-one')
    const chips = Array.from(box.children).filter(el => el.classList.contains('dropdown-blk-chip'))
    const w = box.clientWidth
    const sig = (one ? '' : '?') + chips.map(el => el.textContent + '\u0001' + el.className + '\u0001' + (el.getAttribute('style') || '')).join('\u0002')
    const f = _fit.get(box)
    if (f && f.more === more && f.sig === sig && Math.abs(f.w - w) < 1 && chips.every((el, i) => el.hasAttribute('data-sig-cut') === (f.n >= 0 && i >= f.n))) return
    const st = { sig, w, n: -1, more }
    _fit.set(box, st)
    for (const el of chips) el.removeAttribute('data-sig-cut')
    box.removeAttribute('data-sig-fit')
    if (more) { more.textContent = ''; more.removeAttribute('title') }
    if (!one || !more || !chips.length || !w) return   // с переносом (поиск по форме) — все чипы, без «+k»
    const R = box.getBoundingClientRect().right + 0.5
    const rights = chips.map(el => el.getBoundingClientRect().right)
    if (rights[rights.length - 1] <= R) return   // все помещаются
    more.textContent = '+' + chips.length   // место под хвост — по самому длинному числу
    const room = more.getBoundingClientRect().width + (parseFloat(getComputedStyle(box).columnGap) || 6)
    let n = 0
    while (n < chips.length && rights[n] + room <= R) n++
    n = Math.max(1, n)   // первый (самый значимый) чип — всегда; не влез и с «+k» — сжимается многоточием (data-sig-fit)
    for (let i = n; i < chips.length; i++) chips[i].setAttribute('data-sig-cut', '')
    box.setAttribute('data-sig-fit', '')
    st.n = n
    const k = chips.length - n
    more.textContent = k ? '+' + k : ''   // единственный чип шире строки — только многоточие («+0» не пишется)
    if (k) more.setAttribute('title', tn(k, '+{n} more', '+{n} more') + ':\n' + chips.slice(n).map(el => el.getAttribute('data-sig-full') || el.textContent).join('\n'))
}

export function chipsOneLine_fitAll(root) {
    if (!root || !root.querySelectorAll) return
    for (const box of root.querySelectorAll('.dropdown-sig-chips')) chipsOneLine_fit(box)
}
